import { ChangeList, ProposalControls, targetOf } from './ProposalControls'
import type { ProposalStatus, ProposedAction } from '@/types/investigation'

export { formatValue } from './ProposalControls'

export const STATUS_PILL: Record<ProposalStatus, { label: string; className: string }> = {
  proposed: { label: 'proposed', className: 'bg-etn-info-subtle text-etn-info-text' },
  applying: { label: 'applying', className: 'bg-etn-info-subtle text-etn-info-text' },
  applied: { label: 'applied', className: 'bg-etn-success-subtle text-etn-success-text' },
  dismissed: { label: 'dismissed', className: 'bg-etn-control-subtle text-etn-text-soft' },
  stale: { label: 'out of date', className: 'bg-etn-warning-subtle text-etn-warning-text' },
  failed: { label: 'failed', className: 'bg-etn-danger-subtle text-etn-danger-text' }
}

export function ProposedActions({
  ticketId,
  invId,
  proposals,
  title = 'Proposed changes'
}: {
  ticketId: string
  invId: string
  proposals: ProposedAction[]
  title?: string
}) {
  if (!proposals.length) return null

  return (
    <section className="space-y-2" data-testid="proposed-actions">
      <div>
        <h4 className="text-etn-micro font-semibold uppercase tracking-[0.05em] text-etn-text-label">{title}</h4>
        <p className="text-xs text-etn-text-soft">Nothing changes until a staff member applies it.</p>
      </div>
      <ul className="space-y-2">
        {proposals.map(p => (
          <li
            key={p._id}
            className={`space-y-2 rounded-etn-card border border-etn-border-hairline p-3 ${p.status === 'dismissed' ? 'opacity-60' : ''}`}
            data-testid={`proposal-${p._id}`}
          >
            <div className="flex items-start gap-2">
              <p className="text-sm font-semibold text-etn-text-cell">{p.summary}</p>
              <span className={`ml-auto shrink-0 rounded-etn-pill px-2.5 py-0.5 text-etn-micro font-semibold ${STATUS_PILL[p.status]?.className ?? ''}`}>
                {STATUS_PILL[p.status]?.label ?? p.status}
              </span>
            </div>
            <p className="text-xs text-etn-text-soft">{targetOf(p)}</p>
            {p.rationale && <p className="text-xs text-muted-foreground">{p.rationale}</p>}
            <ChangeList proposal={p} />
            <ProposalControls ticketId={ticketId} invId={invId} proposal={p} />
          </li>
        ))}
      </ul>
    </section>
  )
}
